<template>
    <li @click="toggleMenu()" :class="{ active: active, submenu: hasSubmenu, 'menu-principal-item': principal, 'menu-principal-item--boton': !hasSubmenu }">
        <a :href="href" v-if="externo" :class="{'mm-listitem__text': isMobile}">{{ text  }}</a>

        <Link :href="href" v-if="principal && !externo" :class="{'mm-listitem__text': isMobile}">{{ text }}</Link>
        <a v-if="hasSubmenu && isMobile" class="mm-btn mm-btn_next mm-listitem__btn" :class="{active: isOpen}"></a>
        <div :class="{openMenu: (isOpen && isMobile), submenuMobile: isMobile}" v-if="principal && hasSubmenu && !externo">
            <slot />
        </div>

        <Link :href="href" v-if="!principal && !externo" :class="{'mm-listitem__text': isMobile}">
            <slot />
        </Link>

        <Link :href="href" v-if="html" :class="{'mm-listitem__text': isMobile}">
            <slot />
        </Link>
    </li>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    data() {
        return {
            isOpen: false,
        };
    },
    props:{
        active: Boolean,
        hasSubmenu: Boolean,
        principal: Boolean,
        text: String,
        href: String,
        externo: Boolean,
        isMobile: Boolean,
    },
    components:{ Link },
    methods:{
        toggleMenu(){
            if(this.isMobile){
                this.isOpen = (this.isOpen)?false:true;
            }
        },
    }
}
</script>
